import type React from 'react'
import { Compass, Globe } from 'lucide-react'

function ChromeIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="12" r="4" />
      <path d="M21.17 8H12" />
      <path d="M3.95 6.06 8.54 14" />
      <path d="M10.88 21.94 15.46 14" />
    </svg>
  )
}

function FirefoxIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M12 6c-2 0-4 1-4.5 3-.2.8.5.5 1-.2C9.5 8 10.5 7.5 12 8c2 .7 3 3 2.5 5-.5 1.8-2 3-4 3-2.5 0-4-2-4-4" />
    </svg>
  )
}

function EdgeIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M17 12c0-2.8-2.2-5-5-5s-5 2.2-5 5h7" />
      <path d="M14 12c0 1.7-1.3 3-3 3" />
    </svg>
  )
}

export function getBrowserIcon(browser: string): React.ComponentType<{ className?: string }> {
  const name = browser.toLowerCase()
  if (name.startsWith('chrome')) return ChromeIcon
  if (name.startsWith('safari')) return Compass
  if (name.startsWith('firefox')) return FirefoxIcon
  if (name.startsWith('edge')) return EdgeIcon
  return Globe
}
